<template>
    <NuxtLayout name="malt-full-layout">
        <slot />

        <template #admin-tools>
            <FooterAdminTools>
                <template #cta>
                    <VJoyButton size="small" target="_blank" href="/admin/dashboard/news" variant="admin">Dashboard News</VJoyButton>
                </template>
            </FooterAdminTools>
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {FooterAdminTools} from '#components';
    import {use3rdParties} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';

    use3rdParties();
</script>
